import { ExternalLink } from 'lucide-react';
import { SERVICES } from '../data/services';
import { LOCATIONS } from '../data/locations';
import { PROJECTS } from '../data/projects';
import { POSTS } from '../data/blog';

const CONFIG = {
  projects: { title: 'Projects', items: PROJECTS.map((p) => ({ title: p.title, meta: p.category, url: `/projects/${p.slug}/` })) },
  blog: { title: 'Blog Posts', items: POSTS.map((p) => ({ title: p.title, meta: `${p.category} · ${p.date}`, url: `/blog/${p.slug}/` })) },
  services: { title: 'Services', items: SERVICES.map((s) => ({ title: s.title, meta: s.category, url: `/services/${s.slug}/` })) },
  areas: { title: 'Service Areas', items: LOCATIONS.map((l) => ({ title: `${l.city}, ${l.state}`, meta: l.region, url: `/service-areas/${l.slug}/` })) },
};

const ContentPage = ({ type }) => {
  const cfg = CONFIG[type];
  return (
    <div data-testid={`admin-content-${type}`} className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="font-serif text-3xl font-medium text-ink">{cfg.title}</h1>
        <span className="border border-line px-3 py-1.5 text-xs font-semibold text-muted2">{cfg.items.length} published</span>
      </div>
      <div className="divide-y divide-line border border-line bg-paper">
        {cfg.items.map((it) => (
          <div key={it.url} className="flex items-center justify-between gap-4 px-5 py-4">
            <div className="min-w-0">
              <p className="truncate font-medium text-ink">{it.title}</p>
              <p className="text-xs text-muted2">{it.meta}</p>
            </div>
            <a href={it.url} target="_blank" rel="noreferrer" data-testid={`content-view-${it.url}`} className="inline-flex shrink-0 items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.15em] text-bronze hover:text-ink">
              View <ExternalLink className="h-3.5 w-3.5" />
            </a>
          </div>
        ))}
      </div>
      <p className="text-xs text-muted2">
        Site content is managed in the codebase's CMS-ready data files (/src/data). Editing tools for this content can be layered onto these models when you're ready.
      </p>
    </div>
  );
};

export default ContentPage;
